import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { catchError, tap, throwError } from 'rxjs';
import { HttpResponse } from '@angular/common/http';
import { HomeService } from '../../services/home.service';
import { ModalFormHomeService } from '../../components/modal-form-home/service/modal-form-home.service';
import { FormMensajeSoporteComponent } from '../form-mensaje-soporte/form-mensaje-soporte.component';
import { NoDataComponent } from '../../../../shared/components/no-data/no-data.component';
import { TituloComponent } from '../../../../shared/components/titulo/titulo.component';
import { ButtonPrimaryComponent } from '../../../../shared/components/button-primary/button-primary.component';
import { ButtonSecondaryComponent } from '../../../../shared/components/button-secondary/button-secondary.component';
import { ChipComponent } from '../../../../shared/components/chip/chip.component';
import { ErrorMessageComponent } from '../../../../shared/components/error-message/error-message.component';
import { LoadSpinnerComponent } from '../../../../shared/components/load-spinner/load-spinner.component';
import { MatRadioModule } from '@angular/material/radio';
import { TreeCheckboxSelectComponent } from '../../../../shared/components/tree-checkbox-select/tree-checkbox-select.component';
import { SelectMaterialComponent } from '../../../../shared/components/select-material/select-material.component';
import { InputFieldMaterialComponent } from '../../../../shared/components/input-field-material/input-field-material.component';
import { ReactiveFormsModule } from '@angular/forms';
import { DataErrorComponent } from '../../../../shared/components/data-error/data-error.component';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-modal-home',
  templateUrl: './modal-home.component.html',
  styleUrl: './modal-home.component.scss',
  imports: [
    TituloComponent,
    ButtonPrimaryComponent,
    ButtonSecondaryComponent,
    ErrorMessageComponent,
    MatRadioModule,
    ReactiveFormsModule,
    MatIconModule,
    FormMensajeSoporteComponent,
    CommonModule,
  ],
})
export class HomeModalComponent implements OnInit {
  @ViewChild('form') form: FormMensajeSoporteComponent;
  @Input() menuId: string;
  @Input() accion: string;

  @Output() closeModal: EventEmitter<any> = new EventEmitter<any>();
  isValid: boolean = false;
  isLoading: boolean = false;
  enableButton: boolean = false;
  modalType: string = '';
  error: string = '';
  titulo: string = 'Soporte';
  subtitulo: string = '';
  labelPrimaryButton: string;
  labelSecundaryButton: string;
  isIphone: boolean = false;

  constructor(
    public homeService: HomeService,
    public modalFormHomeService: ModalFormHomeService
  ) {}

  ngOnInit(): void {
    // Detectar iPhone
    const userAgent = navigator.userAgent || navigator.vendor;
    this.isIphone = /iPhone/i.test(userAgent);
    this.modalFormHomeService.formValue.subscribe(value => {
      value ? (this.isValid = true) : (this.isValid = false);
    });
    this.modalFormHomeService.disabledSavingForm.subscribe(value => {
      this.isLoading = value;
    });
    this.modalFormHomeService.modalMode.subscribe((value: boolean) => {
      this.definirModalMode(value);
    });
    this.modalFormHomeService.showingModal.subscribe((value: boolean) => {
      if (!value) {
        this.form?.clearForm();
      }
    });
  }

  definirModalMode(value) {
    if (value == 'enviar') {
      this.modalType = 'enviar';
      this.labelPrimaryButton = 'Enviar';
      this.labelSecundaryButton = 'Cancelar';
      this.enableButton = false;
    } else if (value == 'recibir') {
      //value == ver-editar  es para no volver a cargar los datos del formulario
      this.modalType = 'recibir';
      this.labelPrimaryButton = 'Enviar otra consulta';
      this.labelSecundaryButton = 'Cerrar';
      this.enableButton = true;
    }
  }
  disabledButton(): boolean {
    if (this.enableButton) {
      return false;
    } else {
      const disabled: boolean = !this.isValid || this.isLoading;
      return disabled;
    }
  }
  cancelar() {
    this.modalFormHomeService.showingModalHome.next(false);
    this.modalFormHomeService.closeDrawerHome.next(false);
    this.error = '';
  }

  enviar() {
    if (this.modalType == 'enviar') {
      this.isLoading = true;
      this.modalFormHomeService
        .createSupportTicket()
        .pipe(
          tap((res: any) => {
            this.modalFormHomeService.issuekey.next(res.issueKey);
            this.modalFormHomeService.link.next(res.link);
            this.modalFormHomeService.modalMode.next('recibir');
            this.isLoading = false;
          }),
          catchError(err => {
            //if (err.error?.detail) {
            this.error =
              'No se pudo enviar la consulta, por favor reintenar más tarde o enviar un mail a atentic@cuatroplus.com. ';
            /*} else if (err.status === 0) {
              // Error de red o cuando el puerto está bloqueado
              this.error =
                'Parece que hay un problema de red. Asegúrate de que tienes conexión a Internet o revisa si el puerto está disponible.';
            } else {
              this.error =
                'Ocurrió un error inesperado. Por favor intenta nuevamente más tarde.';
            }*/
            this.isLoading = false;
            return throwError(() => this.error);
          })
        )
        .subscribe();
    } else {
      this.modalFormHomeService.modalMode.next('enviar');
    }
  }
}
